import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  ref?: React.MutableRefObject<HTMLDivElement>;
  layout?: 'position';
  children: React.ReactNode;
  includeTruncate?: boolean;
}

function Element({
  ref,
  layout,
  children,
  includeTruncate = true,
  ...delegated
}: Props) {
  return (
    <Wrapper
      ref={ref}
      // @ts-ignore
      as={layout ? undefined : 'div'}
      layout={layout}
      {...delegated}
    >
      {includeTruncate ? <Truncate>{children}</Truncate> : children}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  max-width: fit-content;
  border: 4px solid hsl(220deg 20% 40%);
  border-radius: 2px;
  color: hsl(220deg 20% 40%);
  padding: 0 16px;
  font-family: var(--font-family-mono);
`;

const Truncate = styled.span`
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
`;

export default Element;
